<template>
  <div>
    <div class="d-flex justify-content-between align-item-center mb-3">
      <div class="section-title">{{ $t('profile') }}</div>
      <!-- <b-button variant="default" to="edit-user" class="btn-blue">{{ $t('edit') }}</b-button> -->

      <button
        v-if="isActive"
        variant="default"
        class="btn-blue"
        @click.prevent.stop="editUsers(true)"
      >{{ $t('edit') }}</button>
      <!-- <div class="section-title">{{ $t('view') }} {{ $tc('user', 1) }}</div> -->
      <!-- <div>
        <router-link
          class="btn-blue"
          :to="{path: 'edit-user',query:{user_id:this.user_id}}"
        >{{ $t('edit') }}</router-link>
        <router-link class="btn-blue" to="users">{{ $tc('user', 2) }} {{ $tc('list', 2) }}</router-link>
      </div>-->
    </div>

    <div class="profile-main-wrapper">
      <div class="row">
        <div class="col-lg-2 col-xl-3 text-center pt-4">
          <!-- <img src="@/assets/img/icons/userProfile.png" class="w-50" alt /> -->
          <img
            v-if="userDetails['user_profile_image_url'] && userDetails.user_profile_image_url.length == 0"
            src="@/assets/img/icons/userProfile.png"
            class="w-50"
            alt
          />
          <img v-else :src="BASE_URL+userDetails.user_profile_image_url" class="w-50" alt />
        </div>
        <div class="col-lg-10 col-xl-9">
          <div
            class="section-title mb-4"
          >{{userDetails.first_name}} {{userDetails.middle_name}} {{userDetails.last_name}}</div>
          <div class="row">
            <div class="col-6">
              <div class="d-flex align-items-center mb-3">
                <vue-material-icon name="mail_outline" :size="20"></vue-material-icon>
                <div class="ml-2">{{userDetails.email_id}}</div>
              </div>

              <div class="d-flex align-items-center mb-3">
                <vue-material-icon name="phone" :size="20" title="asdasd"></vue-material-icon>
                <div class="ml-2">{{userDetails.mobile_no}}</div>
              </div>

              <div class="d-flex align-items-center mb-3">
                <vue-material-icon name="phone" :size="20" title="asdasd"></vue-material-icon>
                <div class="ml-2">{{userDetails.userpin}}</div>
              </div>

              <div class="d-flex align-items-center mb-3">
                <vue-material-icon name="cake" :size="20"></vue-material-icon>
                <!-- <span class="ml-2 lh-1 mt-1">21 March 1996</span> -->
                <span
                  v-if="userDetails['up_dob'] && userDetails.up_dob.length == 0"
                  class="ml-2 lh-1 mt-1"
                >-</span>
                <span v-else class="ml-2 lh-1 mt-1">{{userDetails.up_dob}}</span>
              </div>

              <div class="d-flex align-items-center mb-3">
                <vue-material-icon name="perm_identity" :size="20"></vue-material-icon>
                <!-- <span class="ml-2">Employee-2166</span> -->
                <span class="ml-2">{{userDetails.up_employee_code}}</span>
              </div>
            </div>
            <div class="col-6">
              <div class="d-flex align-items-center mb-3">
                <vue-material-icon name="face" :size="20"></vue-material-icon>
                <!-- <div class="ml-2">Male</div> -->
                <div class="ml-2">{{selected.Gender}}</div>
              </div>

              <div class="d-flex align-items-center mb-3">
                <vue-material-icon name="gps_fixed" :size="20"></vue-material-icon>
                <div
                  class="ml-2"
                >{{selected.City}} {{', '}} {{selected.State}} {{', '}} {{selected.Country}}</div>
                <!-- <div class="ml-2">Malad East, Mumbai Maharashtra</div> -->
              </div>
              <div class="d-flex align-items-center mb-3">
                <span class="text-success lh-1">
                  <vue-material-icon v-if="userDetails.is_active == 'Y'" name="done" :size="20"></vue-material-icon>
                  <vue-material-icon v-else name="cancel" :size="20"></vue-material-icon>
                </span>
                <div v-if="userDetails.is_active == 'Y'" class="ml-2">User Active</div>
                <div v-else class="ml-2">User In Active</div>
              </div>
            </div>

            <!-- OTHER DETAILS -->
            <div class="col-md-12">
              <div class="row">
                <!-- <div class="col-md-12 py-2 border-bottom">
                  <div class="row">
                    <div class="col-md-3 col-lg-2 col-xl-2">{{ $t('employeeid') }}</div>
                    <div
                      v-if="userDetails.up_employee_code"
                      class="col-md-9 col-lg-10 col-xl-10"
                    >{{userDetails.up_employee_code}}</div>
                    <div v-else class="col-md-9 col-lg-10 col-xl-10">-</div>
                  </div>
                </div>-->

                <div class="col-md-12 py-2 border-bottom">
                  <div class="row">
                    <div class="col-md-3 col-lg-2 col-xl-2">{{ $t('username') }}</div>
                    <div
                      v-if="userDetails.username"
                      class="col-md-9 col-lg-10 col-xl-10"
                    >{{userDetails.username}}</div>
                    <div v-else class="col-md-9 col-lg-10 col-xl-10">-</div>
                  </div>
                </div>
                <div class="col-md-12 py-2 border-bottom">
                  <div class="row">
                    <div class="col-md-3 col-lg-2 col-xl-2">{{ $tc('cinema',1) }}</div>
                    <div
                      v-if="selected.Cinemas"
                      class="col-md-9 col-lg-10 col-xl-10"
                    >{{selected.Cinemas}}</div>
                    <div v-else class="col-md-9 col-lg-10 col-xl-10">-</div>
                  </div>
                </div>
                <div class="col-md-12 py-2 border-bottom">
                  <div class="row">
                    <div class="col-md-3 col-lg-2 col-xl-2">{{ $t('department_name') }}</div>
                    <div
                      v-if="userDetails.dept_name"
                      class="col-md-9 col-lg-10 col-xl-10"
                    >{{userDetails.dept_name}}</div>
                    <div v-else class="col-md-9 col-lg-10 col-xl-10">-</div>
                  </div>
                </div>
                <div class="col-md-12 py-2 border-bottom">
                  <div class="row">
                    <div class="col-md-3 col-lg-2 col-xl-2">{{ $tc('designation', 1) }}</div>
                    <div
                      v-if="selected.Designation"
                      class="col-md-9 col-lg-10 col-xl-10"
                    >{{selected.Designation}}</div>
                    <div v-else class="col-md-9 col-lg-10 col-xl-10">-</div>
                  </div>
                </div>

                <div class="col-md-12 py-2 border-bottom">
                  <div class="row">
                    <div class="col-md-3 col-lg-2 col-xl-2">{{ $tc('role', 2) }}</div>
                    <div v-if="selected.Role" class="col-md-9 col-lg-10 col-xl-10">{{selected.Role}}</div>
                    <div v-else class="col-md-9 col-lg-10 col-xl-10">-</div>
                  </div>
                </div>

                <div class="col-md-12 py-2 border-bottom">
                  <div class="row">
                    <div class="col-md-3 col-lg-2 col-xl-2">{{ $t('employeetype') }}</div>
                    <div
                      v-if="userDetails.up_employment_type"
                      class="col-md-9 col-lg-10 col-xl-10"
                    >{{userDetails.up_employment_type}}</div>
                    <div v-else class="col-md-9 col-lg-10 col-xl-10">-</div>
                  </div>
                </div>
                <div class="col-md-12 py-2 border-bottom">
                  <div class="row">
                    <div class="col-md-3 col-lg-2 col-xl-2">{{ $t('phone') }}</div>
                    <div
                      v-if="userDetails.up_alt_contact_no"
                      class="col-md-9 col-lg-10 col-xl-10"
                    >{{userDetails.up_alt_contact_no}}</div>
                    <div v-else class="col-md-9 col-lg-10 col-xl-10">-</div>
                  </div>
                </div>

                <!-- <div class="col-md-12 py-2 border-bottom">
                  <div class="row">
                    <div class="col-md-3 col-lg-2 col-xl-2">{{ $t('employeecode') }}</div>
                    <div
                      v-if="userDetails.up_employee_code"
                      class="col-md-9 col-lg-10 col-xl-10"
                    >{{userDetails.up_employee_code}}</div>
                    <div v-else class="col-md-9 col-lg-10 col-xl-10">-</div>
                  </div>
                </div>-->

                <!-- <div class="col-md-12 py-2 border-bottom">
                  <div class="row">
                    <div class="col-md-3 col-lg-2 col-xl-2">{{ $t('dob') }}</div>
                    <div
                      v-if="userDetails.up_dob"
                      class="col-md-9 col-lg-10 col-xl-10"
                    >{{userDetails.up_dob}}</div>
                    <div v-else class="col-md-9 col-lg-10 col-xl-10">-</div>
                  </div>
                </div>-->

                <div class="col-md-12 py-2 border-bottom">
                  <div class="row">
                    <div class="col-md-3 col-lg-2 col-xl-2">{{ $t('doj') }}</div>
                    <div
                      v-if="userDetails.up_doj"
                      class="col-md-9 col-lg-10 col-xl-10"
                    >{{userDetails.up_doj}}</div>
                    <div v-else class="col-md-9 col-lg-10 col-xl-10">-</div>
                  </div>
                </div>
                <div class="col-md-12 py-2 border-bottom">
                  <div class="row">
                    <div class="col-md-3 col-lg-2 col-xl-2">{{ $t('dol') }}</div>
                    <div
                      v-if="userDetails.up_dol"
                      class="col-md-9 col-lg-10 col-xl-10"
                    >{{userDetails.up_dol}}</div>
                    <div v-else class="col-md-9 col-lg-10 col-xl-10">-</div>
                  </div>
                </div>

                <div class="col-md-12 py-2 border-bottom">
                  <div class="row">
                    <div class="col-md-3 col-lg-2 col-xl-2">{{ $t('address') }}</div>
                    <div
                      v-if="userDetails.up_address1"
                      class="col-md-9 col-lg-10 col-xl-10"
                    >{{userDetails.up_address1}}</div>
                    <div v-else class="col-md-9 col-lg-10 col-xl-10">-</div>
                  </div>
                </div>
                <div class="col-md-12 py-2 border-bottom">
                  <div class="row">
                    <div class="col-md-3 col-lg-2 col-xl-2">{{ $tc('city', 2) }}</div>
                    <div v-if="selected.City" class="col-md-9 col-lg-10 col-xl-10">{{selected.City}}</div>
                    <div v-else class="col-md-9 col-lg-10 col-xl-10">-</div>
                  </div>
                </div>

                <div class="col-md-12 py-2 border-bottom">
                  <div class="row">
                    <div class="col-md-3 col-lg-2 col-xl-2">{{ $tc('state', 1) }}</div>
                    <div
                      v-if="selected.State"
                      class="col-md-9 col-lg-10 col-xl-10"
                    >{{selected.State}}</div>
                    <div v-else class="col-md-9 col-lg-10 col-xl-10">-</div>
                  </div>
                </div>

                <div class="col-md-12 py-2 border-bottom">
                  <div class="row">
                    <div class="col-md-3 col-lg-2 col-xl-2">{{ $t('country') }}</div>
                    <div
                      v-if="selected.Country"
                      class="col-md-9 col-lg-10 col-xl-10"
                    >{{selected.Country}}</div>
                    <div v-else class="col-md-9 col-lg-10 col-xl-10">-</div>
                  </div>
                </div>

                <div class="col-md-12 py-2 border-bottom">
                  <div class="row">
                    <div class="col-md-3 col-lg-2 col-xl-2">{{ $t('zipcode') }}</div>
                    <div
                      v-if="userDetails.zipcode"
                      class="col-md-9 col-lg-10 col-xl-10"
                    >{{userDetails.zipcode}}</div>
                    <div v-else class="col-md-9 col-lg-10 col-xl-10">-</div>
                  </div>
                </div>

                <div class="col-md-12 py-2 border-bottom">
                  <div class="row">
                    <div class="col-md-3 col-lg-2 col-xl-2">{{ $t('rol') }}</div>
                    <div
                      v-if="userDetails.up_reason_for_leaving"
                      class="col-md-9 col-lg-10 col-xl-10"
                    >{{userDetails.up_reason_for_leaving}}</div>
                    <div v-else class="col-md-9 col-lg-10 col-xl-10">-</div>
                  </div>
                </div>

                <!-- <div class="col-md-12 py-2 border-bottom">
                  <div class="row">
                    <div class="col-md-3 col-lg-2 col-xl-2">{{ $t('phone') }}</div>
                    <div
                      v-if="userDetails.up_alt_contact_no"
                      class="col-md-9 col-lg-10 col-xl-10"
                    >{{userDetails.up_alt_contact_no}}</div>
                    <div v-else class="col-md-9 col-lg-10 col-xl-10">-</div>
                  </div>
                </div>-->

                <div v-if="renunciationdata" class="col-md-12 py-2 border-bottom">
                  <div class="row">
                    <div class="col-md-3 col-lg-2 col-xl-2">{{ $t('dol') }}</div>
                    <div
                      v-if="renunciationdata"
                      class="col-md-9 col-lg-10 col-xl-10"
                    >{{ renunciationdata }}</div>
                    <div v-else class="col-md-9 col-lg-10 col-xl-10">-</div>
                  </div>
                </div>

                <div v-if="roleaving" class="col-md-12 py-2 border-bottom">
                  <div class="row">
                    <div class="col-md-3 col-lg-2 col-xl-2">{{ $t('rol') }}</div>
                    <div v-if="roleaving" class="col-md-9 col-lg-10 col-xl-10">{{ roleaving }}</div>
                    <div v-else class="col-md-9 col-lg-10 col-xl-10">-</div>
                  </div>
                </div>

                <!-- <div class="col-md-12 py-2 border-bottom">
                  <div class="row">
                    <div class="col-md-3 col-lg-2 col-xl-2">{{ $tc('status', 1) }}</div>
                    <div
                      v-if="userDetails.up_is_active == 'Y'"
                      class="col-md-9 col-lg-10 col-xl-10"
                    >{{ $t('active') }}</div>
                    <div v-else class="col-md-9 col-lg-10 col-xl-10">{{ $t('inactive') }}</div>
                  </div>
                </div>-->

                <div v-if="login_user_role_id === 1 " class="col-md-12 py-2 border-bottom">
                  <div class="row">
                    <div class="col-md-3 col-lg-2 col-xl-2">{{ $t('createdby') }}</div>
                    <div class="col-md-9 col-lg-10 col-xl-10">
                      <span v-if="userDetails.created_by">{{userDetails.created_by}}</span>
                      <span v-else>-</span>
                    </div>
                  </div>
                </div>

                <div v-if="login_user_role_id === 1 " class="col-md-12 py-2 border-bottom">
                  <div class="row">
                    <div class="col-md-3 col-lg-2 col-xl-2">{{ $t('createdat') }}</div>
                    <div class="col-md-9 col-lg-10 col-xl-10">
                      <span v-if="userDetails.created_at" class="mr-3">{{userDetails.created_at}}</span>
                      <span v-else class="mr-3">-</span>
                      <!-- <span>12:05 AM</span> -->
                    </div>
                  </div>
                </div>

                <div v-if="login_user_role_id === 1 " class="col-md-12 py-2 border-bottom">
                  <div class="row">
                    <div class="col-md-3 col-lg-2 col-xl-2">{{ $t('modifiedby') }}</div>
                    <div class="col-md-9 col-lg-10 col-xl-10">
                      <span v-if="userDetails.updated_by">{{userDetails.updated_by}}</span>
                      <span v-else>-</span>
                    </div>
                  </div>
                </div>

                <div v-if="login_user_role_id === 1 " class="col-md-12 py-2">
                  <div class="row">
                    <div class="col-md-3 col-lg-2 col-xl-2">{{ $t('modifiedat') }}</div>
                    <div class="col-md-9 col-lg-10 col-xl-10">
                      <span v-if="userDetails.updated_at" class="mr-3">{{userDetails.updated_at}}</span>
                      <span v-else class="mr-3">-</span>

                      <!-- <span>12:05 AM</span> -->
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- <div class="text-center mt-5">
      <button class="btn-outline-blue">
        <router-link to="users">{{ $t('cancel') }}</router-link>
      </button>
    </div>-->
  </div>
</template>
<script>
import MasterService from "@/services/MasterService";
import UserService from "@/services/UserService";
import moment from "moment";
import { decryptString, encryptString } from "@/helper/collection";
// import "~material-icons/iconfont/material-icons.scss";

const selected = {
  Country: "",
  Gender: "",
  Cinemas: "",
  Role: "",
  State: "",
  City: "",
  Designation: ""
};

export default {
  data() {
    return {
      login_user_role_id: null,
      userDetails: {
        zipcode: "",
        username: "",
        first_name: "",
        middle_name: "",
        last_name: "",
        email_id: "",
        mobile_no: "",
        cinema_id: "",
        role_id: "",
        password: "",
        userpin: "",
        //userprofileData
        up_employee_code: "",
        up_dob: "",
        up_doj: "",
        up_address1: "",
        up_alt_contact_no: "",
        // dropdown ids
        designation_id: null,
        gender_id: null,
        city_id: null,
        state_id: null,
        country_id: null,
        dept_name: "",
        user_profile_image_url: ""
      },

      selected: selected,

      //
      Genres: [],
      GenresMethod: {
        GET: "/admin/",
        tableName: "ms_genre",
        urlKey: "genres"
      },

      Gender: [],
      GenderMethod: {
        GET: "/admin/",
        tableName: "ms_gender",
        urlKey: "gender"
      },

      Countries: [],
      CountriesMethod: {
        GET: "/admin/",
        tableName: "ms_countries",
        urlKey: "countries"
      },

      States: [],
      StatesMethod: {
        GET: "/admin/tablelist/",
        tableName: "ms_states",
        urlKey: "states"
      },

      Cities: [],
      CitiesMethod: {
        GET: "/admin/tablelist/",
        tableName: "ms_cities",
        urlKey: "cities"
      },

      Roles: [],
      RolesMethod: {
        GET: "/admin/",
        tableName: "ms_roles",
        urlKey: "roles"
      },

      Designations: [],
      DesignationsMethods: {
        GET: "/admin/",
        tableName: "ms_designations",
        urlKey: "designations"
      },

      Cinemas: [],
      CinemasMethods: {
        GET: "/admin/",
        tableName: "ms_cinemas",
        urlKey: "cinemas"
      },
      user_id: "",
      renunciationdata: "",
      roleaving: "",
      isActive: ""
    };
  },
  watch: {
    $route(to, from) {
      console.log("to,from :", to, from);
      this.user_id = to.query.user_id;
      this.getUserDetailsList(this.user_id);
    }
  },
  computed: {
    userDol() {
      return this.$store.getters.userDol;
    },
    userRol() {
      return this.$store.getters.userRol;
    },
    userisActive() {
      return this.$store.getters.userisActive;
    }
  },
  beforeMount() {
    const { uid } = this.$route.query;
    this.renunciationdata =
      this.userDol && isValidDate(new Date(this.userDol))
        ? moment(this.userDol).format("DD-MM-YYYY")
        : "";
    this.roleaving = this.userRol;
    this.userisActive == "N" ? (this.isActive = false) : "";
    function isValidDate(d) {
      if (Object.prototype.toString.call(d) === "[object Date]") {
        // it is a date
        if (isNaN(d.getTime())) {
          return false;
          // d.valueOf() could also work
          // date is not valid
        } else {
          return true;
          // date is valid
        }
      } else {
        return false;
        // not a date
      }
    }

    if (uid) {
      this.getUserDetailsList(uid);
    } else {
      const { key } = this.$route.query;
      let queryParams = this.$route.query;

      if(key) {
        let tempKey = decryptString(key);
        try {
          queryParams = tempKey ? JSON.parse(tempKey) : this.$route.query
        } catch (err) {
          console.log('Error:', err);
        }
      }
      const { user_id } = queryParams;
      this.user_id = user_id;
      if (user_id) {
        this.getUserDetailsList(user_id);
      } else {
        this.$router.go(-1);
      }
    }

    const { role_id } = this.secureStore.get("USINFO");
    // console.log("securee storeage ", this.secureStore.get("USINFO"));
    //   console.log("role nammee", role_name);
    // console.log("Role id", role_id);
    this.login_user_role_id = role_id;
    // console.log("login_user_role ", this.login_user_role_id);
  },
  mounted() {},
  methods: {
    editUsers: function() {
      // const { user_id } = this.$route.query;
      // this.user_id = this.$route.query.user_id;
      // console.log("id ", this.user_id);
      this.$router.push({
        path: "/user-management/edit-user",
        query: { user_id: this.user_id }
      });
    },
    getUserDetailsList: function(user_id) {
      UserService.GetUserDetails({ user_id })
        .then(response => {
          const { data } = response;
          // console.log('Data ',data);
          if (data.status && data.data) {
            this.userDetails = data.data;
            console.log("dataa ", this.userDetails);
            let obj = data.data;
            this.selected.Role = obj.role_name;
            this.userDetails.up_dob =
              obj.up_dob && isValidDate(new Date(obj.up_dob))
                ? moment(obj.up_dob).format("DD-MM-YYYY")
                : "";
            this.userDetails.up_doj =
              obj.up_doj && isValidDate(new Date(obj.up_doj))
                ? moment(obj.up_doj).format("DD-MM-YYYY")
                : "";

            this.userDetails.up_dol =
              obj.up_dol && isValidDate(new Date(obj.up_dol))
                ? moment(obj.up_dol).format("DD-MM-YYYY")
                : "";

            this.userDetails.created_at = obj.created_at
              ? moment(obj.created_at).format("DD-MM-YYYY h:mm a")
              : "";

            this.userDetails["updated_at"] =
              obj.updated_at && obj.updated_at.split("-")[0] != "0000"
                ? moment(obj.created_at).format("DD-MM-YYYY h:mm a")
                : "";
            this.getGenderList(obj.gender_id || null);
            this.getCountriesList(obj.country_id || null);
            this.getStatesList(obj.country_id || null, obj.state_id || null);
            this.getCitiesList(obj.state_id || null, obj.city_id || null);
            this.getRolesList(obj.role_id || null);
            this.getDesignationList(obj.designation_id || null);
            this.getCinemasList(obj.cine_id || obj.cinema_id || null);
            this.getViewUsersDetails(obj.created_by, "created_by");
            this.getViewUsersDetails(obj.updated_by, "updated_by");

            function isValidDate(d) {
              if (Object.prototype.toString.call(d) === "[object Date]") {
                // it is a date
                if (isNaN(d.getTime())) {
                  return false;
                  // d.valueOf() could also work
                  // date is not valid
                } else {
                  return true;
                  // date is valid
                }
              } else {
                return false;
                // not a date
              }
            }
          } else {
            this.$toasted.show(data.message);
          }
        })
        .catch(this._CatchError);
    },

    getViewUsersDetails(user_id, key) {
      if (user_id) {
        MasterService.GetUserInfoById({ user_id })
          .then(response => {
            const { data } = response;
            if (data && data.status && data.Records.length > 0) {
              this.userDetails[key] = data.Records[0].user_name;
            } else {
              this.$toasted.show(data.message);
            }
          })
          .catch(this._CatchError);
      }
    },
    getCinemasList: function(cine_id) {
      this.Cinemas = [];
      let body = this.getRequestBody("GET", undefined, this.CinemasMethods);
      MasterService.GlobalRequest(body)
        .then(response => {
          const { data } = response;
          if (data.status && data.Records.length > 0) {
            this.Cinemas = data.Records;
            if (cine_id) {
              this.Cinemas.map(x => {
                if (cine_id === x.cine_id) {
                  this.selected.Cinemas = x.cine_name;
                }
              });
            }
          } else {
            // this.$toasted.show("2"+data.message);
          }
        })
        .catch(this._CatchError);
    },
    getRolesList: function(role_id) {
      this.Roles = [];
      let body = this.getRequestBody("GET", undefined, this.RolesMethod);
      MasterService.GlobalRequest(body)
        .then(response => {
          const { data } = response;
          if (data.status) {
            if (data.Records.length > 0) {
              this.Roles = data.Records;
              // this.getUserDetails(user_id);
              if (role_id) {
                this.Roles.map(x => {
                  // console.log("x :", x);
                  if (String(role_id) === String(x.role_id)) {
                    this.selected.Role = x.role_name;
                  }
                });
              }
              // else{
              //   this.selected.Role = "-";
              // }
            }
          } else {
            this.$toasted.show(data.message);
          }
        })
        .catch(this._CatchError);
    },

    getGenderList: function(gender_id) {
      this.Gender = [];
      let body = this.getRequestBody("GET", undefined, this.GenderMethod);
      MasterService.GlobalRequest(body)
        .then(response => {
          const { data } = response;
          if (data.status && data.Records.length > 0) {
            this.Gender = data.Records;
            console.log("Gender ", this.Gender);
            if (gender_id) {
              this.Gender.map(x => {
                if (x.gender_id === gender_id) {
                  this.selected.Gender = x.gender;
                }
              });
            }
          } else {
            //     this.$toasted.show("4"+data.message);
          }
        })
        .catch(this._CatchError);
    },
    getCountriesList: function(country_id) {
      this.Countries = [];
      let body = this.getRequestBody("GET", undefined, this.CountriesMethod);
      MasterService.GlobalRequest(body)
        .then(response => {
          const { data } = response;
          if (data.status && data.Records.length > 0) {
            this.Countries = data.Records;
            if (country_id) {
              this.Countries.map(x => {
                if (country_id === x.country_id) {
                  this.selected.Country = x.country_name;
                }
              });
            }
          } else {
            //  this.$toasted.show("5"+data.message);
          }
        })
        .catch(this._CatchError);
    },
    getStatesList: function(country_id, state_id) {
      this.States = [];
      let body = this.getRequestBody("GET", undefined, {
        ...this.StatesMethod,
        params: { id: "country_id-" + country_id }
      });
      MasterService.GlobalRequest(body)
        .then(response => {
          const { data } = response;
          if (data.status && data.Records.length > 0) {
            this.States = data.Records;

            console.log("States ", this.States);
            console.log("States Id ", state_id);

            if (state_id) {
              this.States.map(x => {
                if (state_id === x.state_id) {
                  this.selected.State = x.state_name;
                  console.log(" this.selected.State ", this.selected.State);
                }
              });
            }
          } else {
            // this.$toasted.show("state"+data.message);
          }
        })
        .catch(this._CatchError);
    },
    getCitiesList: function(state_id, city_id) {
      this.Cities = [];
      let body = this.getRequestBody("GET", undefined, {
        ...this.CitiesMethod,
        params: { id: "state_id-" + state_id }
      });
      MasterService.GlobalRequest(body)
        .then(response => {
          const { data } = response;
          if (data.status && data.Records.length > 0) {
            this.Cities = data.Records;
            if (city_id) {
              this.Cities.map(x => {
                if (city_id === x.city_id) {
                  this.selected.City = x.city_name;
                }
              });
            }
          } else {
            //  this.$toasted.show("City"+data.message);
          }
        })
        .catch(this._CatchError);
    },
    getDesignationList: function(designation_id) {
      this.Designations = [];
      let body = this.getRequestBody(
        "GET",
        undefined,
        this.DesignationsMethods
      );
      MasterService.GlobalRequest(body)
        .then(response => {
          const { data } = response;
          if (data.status) {
            if (data.Records.length > 0) {
              this.Designations = data.Records;
              if (designation_id) {
                this.Designations.map(x => {
                  if (designation_id === x.designation_id) {
                    this.selected.Designation = x.designation;
                  }
                });
              }
            }
          } else {
            //    this.$toasted.show("last"+data.message);
          }
        })
        .catch(this._CatchError);
    },
    onSelectHandler: function(type, value) {
      if (type == "role") {
        this.selectedRole.label = value.role_name;
        this.selectedRole.value = value.role_id;
      } else if (type == "cinema") {
        this.selectedCinema.label = value.cine_name;
        this.selectedCinema.value = value.cine_id;
      }
    }
  }
};
</script>

<style>
.profile-main-wrapper {
  padding: 15px;
  border-radius: 10px;
  margin-bottom: 30px;
  background-color: #fff;
  box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.15);
}
</style>

 


// WEBPACK FOOTER //
// src/components/Pages/UserManagement/UsersComponents/viewUser.vue